import React from "react";
import {
  Box,
  TableContainer as MuiTableContainer,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MobileTableView from "./MobileTableView";
import DataGridTable from "./DataGridTable";
import {
  GridCallbackDetails,
  GridCellParams,
  GridColumnVisibilityModel,
  GridFilterModel,
} from "@mui/x-data-grid";
import SearchParams, { OrderDirection } from "../../types/searchParams";
import ColumnDef from "../../types/columnDef";

interface Props {
  page?: number;
  pageSize?: number;
  changePage?: (pageNumber?: number, pageSize?: number) => void;
  totalRows?: number;
  columns: ColumnDef[];
  rows: any[];
  mobileRows: any[];
  next?: () => void;
  allowExport?: boolean;
  loading?: boolean;
  onCellClick?: (params: any) => void;
  getCellClassName?: (params: GridCellParams<any, any, any>) => string;
  handleSort?: (orderBy?: string, orderDirection?: OrderDirection) => void;
  highlightId?: number;
  backgroundColor?: string;
  mobileBackgroundColor?: string;
  columnVisibility?: GridColumnVisibilityModel;
  handleColumnVisibilityChange?: (
    model: GridColumnVisibilityModel,
    details: GridCallbackDetails,
  ) => void;
  filterModel?: GridFilterModel;
  handleFilterModelChange?: (
    model: GridFilterModel,
    details: GridCallbackDetails<"filter">,
  ) => void;
  handleFilterManage?: () => void;
  handleSaveFilterSet?: () => void;
  filters?: SearchParams;
  reportStart?: Date;
  reportEnd?: Date;
}

const TableContainer: React.FC<Props> = (props) => {
  const { columns } = props;

  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Box sx={{ maxWidth: "100%" }}>
      <MuiTableContainer>
        {desktop ? (
          <DataGridTable {...props} />
        ) : (
          <MobileTableView
            {...props}
            headers={columns.map((c) => {
              return {
                field: c.field,
                headerName: c.headerName ?? "",
                mobileSize: c.mobileSize,
                mobileDirection: c.mobileDirection,
              };
            })}
          />
        )}
      </MuiTableContainer>
    </Box>
  );
};

export default TableContainer;
